var _defaultValues;
import { METHOD, SEPA_ACCOUNT_OWNER, SEPA_BANK, SEPA_BIC, SEPA_IBAN, STRIPE_TOKEN } from "./field-names";
import { PaymentMethod } from "../../../../util/subscription/enums";
export var defaultValues = (_defaultValues = {}, _defaultValues[METHOD] = PaymentMethod.SEPA, _defaultValues[SEPA_ACCOUNT_OWNER] = "", _defaultValues[SEPA_BIC] = "", _defaultValues[SEPA_IBAN] = "", _defaultValues[SEPA_BANK] = "", _defaultValues[STRIPE_TOKEN] = "", _defaultValues);
